/** @file Copied dopesheet keys for Mod+V (editor session only, never the system clipboard). */
import { createStore } from 'zustand/vanilla';
import type { KeyClip } from './model/keyCommands';

/** null until the first copy. */
export const keyClipboardStore = createStore<{ clip: KeyClip | null }>()(() => ({ clip: null }));
